
(function () {
    'use strict';

    angular
            .module('caloappApp')
            .controller('CaloriesModalController', CaloriesModalController);

    CaloriesModalController.$inject = ['$rootScope', '$state', '$timeout', '$uibModalInstance',
        'mealInformation', '$stateParams', 'CaloriesService'];

    function CaloriesModalController($rootScope, $state, $timeout, $uibModalInstance,
            mealInformation, $stateParams, CaloriesService) {
        var vm = this;

        vm.userLogin = $stateParams.username;


        // boolean informing whether the saving action is performing
        vm.isSaving = false;

        vm.editionOrCreationError = false;
        vm.cancel = cancel;
        vm.credentials = {
            id: null,
            calories: null,
            description: null,
            date: null,
            time: null
        };

        $timeout(function () {
            angular.element('#meal').focus();
        });

        // this method transforms a time represented in ms to a valid date
        vm.getTime = getTime;

        // this method is called to init the page
        vm.init = init;

        // this method is called to save the new/updated meal information
        vm.save = save;

        vm.init();

        function init() {
            // case we are updating a meal information
            if (mealInformation) {
                vm.credentials = {
                    id: mealInformation.id,
                    calories: mealInformation.calories,
                    description: mealInformation.description,
                    date: mealInformation.date ? new Date(mealInformation.date) : null,
                    time: mealInformation.time ? vm.getTime(mealInformation.time) : null
                };
            }

        }

        function getTime(aTimeInMs) {
            // get the number of hours
            var lNbHours = parseInt(aTimeInMs / (3600 * 60));
            var lNbMinutes = parseInt((aTimeInMs % (3600 * 60)) / 3600);

            // the date to return
            var lDate = new Date();
            lDate.setHours(lNbHours);
            lDate.setMinutes(lNbMinutes);
            lDate.setSeconds(0);
            lDate.setMilliseconds(0);

            return lDate;
        }

        function save(event) {

            // method called when the update/creation is successful
            function onSaveSuccess(result) {
                vm.isSaving = false;
                $uibModalInstance.close(result);
            }

            // method called when the update/creation failed
            function onSaveFailure() {
                vm.isSaving = false;
                vm.editionOrCreationError = true;
            }

            vm.editionOrCreationError = false;
            event.preventDefault();
            if (!vm.isSaving) {

                vm.isSaving = true;

                var credentialsToSend = {
                    id: vm.credentials.id,
                    userLogin: vm.userLogin,
                    description: vm.credentials.description,
                    calories: vm.credentials.calories
                };

                // we process the date to get the number of ms
                var lDate = new Date(vm.credentials.date);
                // we put the date 01:00 to be able to filter them quickly later
                lDate.setHours(1);
                lDate.setMinutes(0);

                credentialsToSend.date = Number(lDate.getTime());

                // we process the time to get the number of ms
                var lTime = new Date(vm.credentials.time);
                var lNbHours = lTime.getHours();
                var lNbMinutes = lTime.getMinutes();

                credentialsToSend.time = Number(((lNbHours * 60) + lNbMinutes) * 3600);

                // depending on whether it is a creation or an update we will call a different WS
                // case it is an update the id is inquired
                if (vm.credentials.id) {
                    CaloriesService.update(credentialsToSend, onSaveSuccess, onSaveFailure);
                }
                // case the user creates a new meal information
                else {
                    CaloriesService.save(credentialsToSend, onSaveSuccess, onSaveFailure);
                }

            }



        }



        function cancel() {
            vm.credentials = {
                id: null,
                calories: null,
                description: null,
                date: null,
                time: null
            };
            vm.editionOrCreationError = false;
            $uibModalInstance.dismiss('cancel');
        }


    }
})();
